import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useRanger } from "@tanstack/react-ranger";
import { Caption, Mark, Segment, SliderWrapper, Thumb, ThumbLabel, getIteratorObject, isNumberInRange } from "../components";
const CenteredSlider = ({ min, max, onChange, value, measuringUnit, customSteps, customMarks, customCaptions, hasTooltip }) => {
    const rangerRef = React.useRef(null);
    const [values, setValues] = React.useState([value ?? customSteps[2]]);
    const marksObject = getIteratorObject(max, min, Boolean(customSteps?.length), customMarks);
    useEffect(() => {
        setValues([value ?? customSteps[2]]);
    }, [value, customSteps]);
    const captionsObject = getIteratorObject(max, min, false, customCaptions);
    const handleChange = (instance) => {
        onChange(instance.sortedValues);
        setValues(instance.sortedValues);
    };
    const handleDrag = (instance) => {
        onChange(instance.sortedValues);
        setValues(instance.sortedValues);
    };
    const fixedSizeSegmentsStepsInterpolator = {
        getPercentageForValue: (val) => {
            const index = customSteps.findIndex((step) => step === val);
            const percentage = Math.ceil((100 / (customSteps.length - 1)) * index);
            return percentage;
        },
        getValueForClientX: (clientX, trackDims, min, max) => {
            const { left, width } = trackDims;
            const percentageValue = (clientX - left) / width;
            const value = (max - min) * percentageValue;
            return value + min;
        },
    };
    const rangerInstance = useRanger({
        getRangerElement: () => rangerRef.current,
        values,
        min,
        max,
        stepSize: 1,
        steps: customSteps,
        onChange: handleChange,
        onDrag: handleDrag,
        interpolator: fixedSizeSegmentsStepsInterpolator,
    });
    const middlePercentage = rangerInstance.getPercentageForValue(Math.floor((max + min) / 2));
    return (_jsx(SliderWrapper, { children: _jsxs("div", { ref: rangerRef, className: "relative h-1 w-full rounded-full bg-gray-light", children: [(marksObject ?? rangerInstance.getTicks()).map(({ value, key, percentage }) => (_jsx(Mark, { percentage: percentage, isActive: isNumberInRange(value, [customSteps[2], values[0]]) }, key))), (captionsObject ?? rangerInstance.getTicks()).map(({ value, key, percentage }) => (_jsxs(Caption, { percentage: percentage, children: [value, " ", measuringUnit] }, key))), _jsx(Segment, { left: rangerInstance.getPercentageForValue(values[0]) > middlePercentage ? middlePercentage : rangerInstance.getPercentageForValue(values[0]) + 0.5, width: Math.abs(rangerInstance.getPercentageForValue(values[0]) - middlePercentage) }), rangerInstance.handles().map(({ value, onKeyDownHandler, onMouseDownHandler, onTouchStart, isActive }) => (_jsxs("div", { children: [_jsx(Thumb, { value: value, onKeyDownHandler: onKeyDownHandler, onMouseDownHandler: onMouseDownHandler, onTouchStart: onTouchStart, min: rangerInstance.options.min, max: rangerInstance.options.max, isActive: isActive, percentageForValue: rangerInstance.getPercentageForValue(value) }, `value-${value}-${isActive}`), hasTooltip && _jsx(ThumbLabel, { value: value, measuringUnit: measuringUnit, percentageForValue: rangerInstance.getPercentageForValue(value) })] }, value)))] }) }));
};
export default CenteredSlider;
